export enum ApplicationBuildTypes
{
    DEBUG, PRODUCTION
}

export class ApplicationBuild
{
    private static BASE_PATH: string;

    static setBuild(applicationBuildTypes: ApplicationBuildTypes)
    {
        this.BASE_PATH = window.location.protocol +'//'+ window.location.hostname
        + ':' + window.location.port + "/";

        applicationBuildTypes === ApplicationBuildTypes.PRODUCTION 
                && (this.BASE_PATH = this.BASE_PATH + window.location.pathname.split('/')[1] + "/");
    }
  
    static getBaseURL(): string
    {
        return this.BASE_PATH;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/property/applicationbuild.ts